/* istanbul ignore file */
import styled, { css } from 'styled-components';
import { colors, breakpoints, zindex } from '@chegg-ui/theme';
import { GRID_WRAPPER_CONTENT_CLASS, GRID_WRAPPER_FOOTER_CLASS } from './constants';
export var GridWrapper = styled.div.withConfig({
  componentId: "sc-7x03gh-0"
})(["height:100%;display:grid;grid-template-rows:1fr max-content;max-height:", ";background:", ";.", "{overflow-y:auto;padding:0 10px 20px;}@media screen and (max-width:", "){.", "{padding-right:5px;padding-left:5px;}}.", "{box-shadow:0 -16px 16px -16px rgba(34,34,34,0.5);z-index:", ";}@media screen and (max-width:", "){height:100%;", "}"], function (_ref) {
  var hasNeedHelpButton = _ref.hasNeedHelpButton;
  return hasNeedHelpButton ? '80vh' : '90vh';
}, colors.white, GRID_WRAPPER_CONTENT_CLASS, breakpoints.sm.max, GRID_WRAPPER_CONTENT_CLASS, GRID_WRAPPER_FOOTER_CLASS, zindex.layout, breakpoints.md.max, function (_ref2) {
  var disableStickyFooter = _ref2.disableStickyFooter;
  return disableStickyFooter && css(["grid-template-rows:none;overflow:auto;.", "{box-shadow:none;}"], GRID_WRAPPER_FOOTER_CLASS);
});
export var GridFooter = styled.div.withConfig({
  componentId: "sc-7x03gh-1"
})(["display:flex;", " @media screen and (max-width:", "){button{width:100%;}> div{border-top:none;}}"], function (_ref3) {
  var direction = _ref3.direction;
  return "\n    flex-direction: ".concat(direction, ";\n    ").concat(direction === 'column' && css(["padding:5px 10px 0px 10px;"]), ";\n\n    ").concat(direction === 'row' && css(["> div{padding:5px 5px 0px 5px;}"]), ";\n    @media screen and (max-width: ").concat(breakpoints.sm.max, ") {\n      ").concat(direction === 'column' && css(["padding-right:5px;padding-left:5px;"]), ";\n    }\n  ");
}, breakpoints.md.max);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/components/modules/GridLayout/styled.js
// module id = 1461
// module chunks = 11